import Axios from 'axios';
import { Payload } from '../constants/payload.model';

const AGG_API = `${process.env.VUE_APP_AGG_API}`;
const MEMBERSHIP_API = `${process.env.VUE_APP_MEMBERSHIP_API}`;
const MEMBER_PROFILE_API = `${process.env.VUE_APP_MEMBERPROFILE_API}`;
const CP_SERVICES = `${process.env.VUE_APP_CP_ENDPOINT}`;

const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};


export default {

    async getMemberStatus(memberId) {

        const options = new Payload(`${AGG_API}/v1/profile/get/${memberId}/Chileautos.CL`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);

            throw new Error(error);
        }
    },

    async updateMemberStatusV2(memberId, status) {

        try {
            const payload = {
                status: status,
                service: "chileautos"
            };
    
            const options = new Payload(`${MEMBER_PROFILE_API}/member/${memberId}`, 'PUT', payload);
          
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
            throw new Error(error);
        }

    },
    async removeMemberCookie(memberId) {

        try {
            const optionsMember = new Payload(`${MEMBERSHIP_API}/v1/tokens/members/${memberId}?tokenType=LatamJWT`, 'DELETE');
            const responseMember = await apiProxy(optionsMember);
            const dataMember = await responseMember.data;
            return dataMember;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
            throw new Error(error);
        }

    },
    async updateMemberStatus(memberId, status) {

        const data = {
            memberId,
            status,
            tenant: "Chileautos.CL"
        };

        const options = new Payload(`${AGG_API}/v1/profile/updatestatus`, 'POST', data);
        options.withCredentials('AppId', "AppId");
        options.withCredentials('AppSecret', "AppSecret");

        try {
            if (status == 'Inactive') {
                const optionsMember = new Payload(`${MEMBERSHIP_API}/v1/tokens/members/${memberId}?tokenType=LatamJWT`, 'DELETE');
                const responseMember = await apiProxy(optionsMember);
                const dataMember = await responseMember.data;
            }

            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
            throw new Error(error);
        }

    },
    async CP_ActiveService(sellerIdentifier) {

        const data = {
            description: "",
            code: "CA",
            identifier: '8c2f1491-0ef0-4c1f-808a-cb1bfd57e868',
            status: "active",
            name: "ChileAutos"
        }

        const options = new Payload(`${CP_SERVICES}/items/${sellerIdentifier}/services`, 'POST', data);

        options.withCredentials('x-user-identifier', sellerIdentifier);

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
            throw new Error(error);
        }

    },
    async CP_RemoveService(sellerIdentifier) {

        const data = {}

        const options = new Payload(`${CP_SERVICES}/items/${sellerIdentifier}/services/8c2f1491-0ef0-4c1f-808a-cb1bfd57e868`, 'DELETE', data);

        options.withCredentials('x-user-identifier', sellerIdentifier);

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if (error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
            throw new Error(error);
        }

    }

}